
export const tokenSilentlyOption = {
  audience: 'client_api',
  issuer: 'https://login.renjuportal.com/',
}

export const auth0ClientOption = {
  domain: 'login.renjuportal.com',
  client_id: 'SigabIkTSA0K8L5lziSC3WemNYIQfzsx'
}


// WEBPACK FOOTER //
// ./src/lib/Auth0.js